/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SET_CLIENTS,
  SET_CLIENTS_ERROR,
  SET_CLIENTS_REQUEST
} from 'src/actions/clientsActions';

const initialState = {
  clients: null,
  isLoading: false,
  error: null
};

const clientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENTS_REQUEST: {
      return produce(state, (draft) => {
        draft.isLoading = true;
        draft.error = null;
      });
    }

    case SET_CLIENTS: {
      let clients;
      if (action.payload?.clients) {
        clients = action.payload.clients;
      } else if (action.payload) {
        clients = action.payload;
      } else {
        clients = [];
      }

      return produce(state, (draft) => {
        draft.clients = clients;
        draft.isLoading = false;
        draft.error = null;
      });
    }

    case SET_CLIENTS_ERROR: {
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = action.payload;
      });
    }

    default: {
      return state;
    }
  }
};

export default clientsReducer;
